class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.bindOverlay();
    this.setHeaderCartIconAccessibility();
  }

  bindOverlay() {
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    this.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');

    const drawerInner = this.querySelector('.drawer__inner, .drawer__inner-empty');
    if (drawerInner) trapFocus(drawerInner, drawerInner);
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents() {
    if (!this.classList.contains('active')) {
      this.open();
    }
  }

  getSectionsToRender() {
    return [];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  constructor() {
    super();
  }

  getSectionsToRender() {
    return [];
  }

  enableLoading() {}

  disableLoading() {}

  onCartUpdate() {
    window.NihooyaCart?.fetchCart()
      .then((cart) => window.NihooyaCart?.syncDrawerFromCart(cart))
      .catch((error) => console.error(error));
  }

  connectedCallback() {
    super.connectedCallback();
    this._clickHandler = this.handleQuantityClick.bind(this);
    this.addEventListener('click', this._clickHandler, true);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this._clickHandler, true);
  }

  handleQuantityClick(event) {
    const button = event.target.closest('.quantity__button');
    if (!button) return;

    const input = button.closest('quantity-input')?.querySelector('.quantity__input');
    if (!input?.dataset?.index) return;

    event.preventDefault();
    event.stopPropagation();

    const line = parseInt(input.dataset.index, 10);
    const current = parseInt(input.value || '0', 10) || 0;
    const next = button.name === 'plus' ? current + 1 : Math.max(0, current - 1);

    this.updateQuantity(line, next);
  }

  onChange(event) {
    if (!event.target?.dataset?.index) return;
    this.updateQuantity(event.target.dataset.index, event.target.value);
  }

  syncDrawerAfterChange(cart, line, previousQuantity) {
    if (cart?.errors) {
      if (previousQuantity !== undefined) {
        window.NihooyaCart?.optimisticQuantityChange(line, parseInt(previousQuantity, 10));
      }
      this.updateLiveRegions(line, cart.errors);
      window.NihooyaCart?.setSubtotalPending(false);
      return;
    }

    if (!cart) {
      window.NihooyaCart?.setSubtotalPending(false);
      return;
    }

    window.NihooyaCart?.syncDrawerFromCart(cart);

    if (cart.item_count === 0) {
      window.NihooyaCart?.closeDrawerIfEmpty(0);
    }

    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
  }

  updateQuantity(line, quantity) {
    const parsedQuantity = parseInt(String(quantity), 10);
    if (Number.isNaN(parsedQuantity)) return;

    const quantityElement = document.getElementById(`Drawer-quantity-${line}`);
    const previousQuantity = quantityElement?.value;

    window.NihooyaCart?.optimisticQuantityChange(line, parsedQuantity);

    const syncQuantity =
      parsedQuantity === 0
        ? window.NihooyaCart?.changeLine(line, parsedQuantity)
        : window.NihooyaCart?.debouncedChangeLine(line, parsedQuantity);

    Promise.resolve(syncQuantity)
      .then((cart) => this.syncDrawerAfterChange(cart, line, previousQuantity))
      .catch(() => {
        if (previousQuantity !== undefined) {
          window.NihooyaCart?.optimisticQuantityChange(line, parseInt(previousQuantity, 10));
        }
        window.NihooyaCart?.setSubtotalPending(false);
        const errors = document.getElementById('CartDrawer-CartErrors');
        if (errors) errors.textContent = window.cartStrings.error;
      });
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);